import { checkIsStringEmpty } from "repoV2/utils/common/dataTypes/string";
import { DIGITS_REGEX } from "repoV2/utils/common/validators/regex.constants";

export const validatePhoneNumber = ({
    phoneNumber,
    isInIndia = false,
}: {
    phoneNumber: string;
    isInIndia?: boolean;
}) => {
    if (checkIsStringEmpty(phoneNumber)) return "Please Enter Phone Number";
    if (!DIGITS_REGEX.test(phoneNumber))
        return "Phone number can only have digits";
    if (isInIndia) {
        if (phoneNumber.length !== 10) {
            return "Phone number can only be 10 digits long";
        }
    } else {
        if (phoneNumber.length < 4) return "Phone number too short";
        if (phoneNumber.length > 16) return "Phone number too long";
    }
};

export const required = (value?: string) => (value ? undefined : "Required");

export const maxLength = (length: number) => (input: string) =>
    input.length > length
        ? `Input exceeds the maximum allowed length of ${length} characters.`
        : undefined;
